import { ShieldCheck, SlidersHorizontal, Handshake } from "lucide-react";

const WhySection = ({ language }) => {

  const lang = language === "CN" ? "zh" : "en";

  const content = {
    en: {
      subtitle: "WHY JT GROUP",
      title: "What Sets Us Apart",
      features: [
        {
          title: "Trusted Expertise",
          desc: "Award-winning advisors with deep knowledge across life, health, wealth, and legacy planning.",
          icon: ShieldCheck,
        },
        {
          title: "Tailored Solutions",
          desc: "No two clients are alike. Every plan we craft is bespoke, built around your unique needs and aspirations.",
          icon: SlidersHorizontal,
        },
        {
          title: "Lasting Relationships",
          desc: "We measure our success not by transactions, but by the enduring relationships we build with every client.",
          icon: Handshake,
        },
      ],
    },

    zh: {
      subtitle: "为什么选择 JT GROUP",
      title: "我们的优势",
      features: [
        {
          title: "值得信赖的专业经验",
          desc: "屡获殊荣的顾问团队，在寿险、健康、财富与传承规划方面拥有深厚经验。",
          icon: ShieldCheck,
        },
        {
          title: "量身定制方案",
          desc: "每位客户都不同，我们为您的需求和目标打造专属解决方案。",
          icon: SlidersHorizontal,
        },
        {
          title: "长期合作关系",
          desc: "我们的成功不仅来自交易，更来自与客户建立的长期信任关系。",
          icon: Handshake,
        },
      ],
    },
  };

  return (
    <section className="bg-[#1f4b5e] py-10">
      <div className="max-w-[1320px] mx-auto px-4 text-center">

        {/* Subtitle */}
        <p className="text-[#C69C6D] font-semibold tracking-wide">
          {content[lang].subtitle}
        </p>

        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-medium text-white mt-3">
          {content[lang].title}
        </h2>

        {/* Features */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12 mt-10">

          {content[lang].features.map((item, index) => {
            const Icon = item.icon;

            return (
              <div key={index} className="text-center group">

                <div
                  className="w-16 h-16 mx-auto flex items-center justify-center 
                  rounded-full 
                  border border-[#C2976C]/30 
                  bg-[#C2976C]/10 
                  mb-6
                  transition-all duration-300
                  group-hover:bg-[#C2976C]"
                >
                  <Icon
                    size={26}
                    className="text-[#C2976C] transition-all duration-300 group-hover:text-white"
                  />
                </div>

                <h3 className="text-lg font-semibold text-white mb-3">
                  {item.title}
                </h3>

                <p className="text-gray-300 text-sm leading-relaxed max-w-[350px] mx-auto">
                  {item.desc}
                </p>

              </div>
            );
          })}

        </div>

      </div>
    </section>
  );
};

export default WhySection;